export default {
  externalTransfers: 'Chuyển khoản đến tài khoản ngoài',
  internalTransfer: 'Chuyển đến tài khoản đã liên kết',
  AutWithdrawalType: 'Loại rút tiền tự động',
  step1: 'otp',
  step2: 'smartOtp',
  step3: 'Hoàn thành',
  payment: 'Trả tiền thay mặt cho',
  ispayment: 'Trả tiền thay mặt cho',
  AutoPayment: 'Thanh toán tự động hàng loạt',
  channelType: 'Loại kênh ba chiều',
  supplier: 'nhà cung cấp',
  subotp: 'Gửi mã xác minh',
  receipt: 'biên lai',
  zalopayId: 'số tài khoản zalo',
  enterotp: 'Vui lòng nhập mã xác minh',
  payinfo: 'thông tin người nhận tiền',
  paycode: 'Mã QR thanh toán',
  paycode1: 'Bộ sưu tập',
  paycode2: 'Pha Chế',
  transCode: '交易码',
  confirm: 'Gửi',
  serialNumber: 'số thiết bị',
  userName: 'tên tài khoản',
  phone: 'Số điện thoại di động',
  connectionStatus: 'Trạng thái kết nối',
  limits: 'Giới hạn giới hạn trong ngày',
  monthLimits: 'Giới hạn của tháng hiện tại',
  gotDayMoney: 'Số tiền nhận được trong ngày',
  receivedTotalMoney: 'Tổng số tiền đã nhận',
  id: 'id',
  payOrder: 'Số giao dịch',
  deviceOrder: 'số thiết bị',
  payType: 'loại chuyển nhượng',
  payMoney: 'số tiền giao dịch',
  remark: 'Mô tả',
  callbackStatus: 'trạng thái gọi lại',
  createTime: 'Ngày tạo',
  tranid: 'số giao dịch',
  tranType: 'loại chuyển giao',
  amount: 'số tiền giao dịch',
  description: 'Mô tả',
  updates: 'Tải lên',
  exportIn: 'nhập dữ liệu',
  orderNumberTotal: 'Số lượng giao dịch',
  paymentAmountTotal: 'Tổng số tiền đã nhận',
  history: 'Lịch sử',
  bankName: 'Tên ngân hàng',
  bankAccount: 'Số thẻ ngân hàng',
  bankCode: 'mã ngân hàng',
  payName: 'tên người nhận tiền',
  loginAccount: 'tài khoản đăng nhập',
  proQrStatus: 'Trạng thái mã chung',
  bankQrStatus: 'Trạng thái quét mã ngân hàng',
  momoBankStatus: 'trạng thái ngân hàng momo',
  bankTransferStatus: 'Trạng thái chuyển khoản thẻ ngân hàng',
  apiStatus: 'api pull record status',
  momo_bankStatus: 'tình trạng ngân hàng momobank',
  zalobankStatus: 'Trạng thái ngân hàng Zalobank',
  vtpbankStatus: 'tình trạng ngân hàng vtpbank',

  balance: 'số dư tài khoản',
  successTodayAmount: 'Số tiền giao dịch thành công trong ngày',
  content: 'Nội dung',
  source: 'nguồn',
  accountNumber: 'số tiền giao dịch',
  io: 'loại chuyển nhượng',
  partnerPhone: 'số điện thoại thanh toán',
  finishTime: 'Chuyển thời gian',
  fee: 'phí xử lý',
  apptrandsId: 'apptransid',
  sourceType: 'Ghi nguồn',
  systemOrderNo: 'số thứ tự hệ thống',
  status: 'Trạng thái giao dịch',
  senderAccount: 'tài khoản rút tiền',
  senderName: 'Tên rút tiền',
  senderBankCode: 'ngân hàng rút tiền',
  receiverNumber: 'số tài khoản người nhận',
  receiverName: 'Tên người nhận',
  receiverBankCode: 'ngân hàng người nhận',
  createDate: 'Thời gian tạo',
  createBy: 'Người tạo',
  confirmDate: 'Thời gian xác nhận',
  confirmBy: 'Toán tử rút tiền',
  error: 'thông báo lỗi',
  payBankId: 'id ngân hàng thanh toán',
  offstatus: 'trạng thái hoạt động',
  Changestate: 'Mở hay không',
  changestateoff: 'Đóng cửa hay không',
  minimumAmount: 'Số tiền thanh toán tối thiểu',
  maximumAmount: 'Số tiền thanh toán tối đa',
  withdrawTodayAmount: 'Số tiền rút trong ngày',
  IsOnline: 'Đang trực tuyến',
  onlineStatus: 'trạng thái trực tuyến',
  AutCollection: 'Rút tiền tự động',
  state: 'tình trạng',
  activation: 'kích hoạt',
  unactivation: 'Vô hiệu hóa',
  Operator: 'Nhà điều hành',
  connection: 'kết nối',
  unconnection: 'ngắt kết nối',
  phoneAndUser: 'Số điện thoại di động/tên người dùng',
  withdrawMoney: 'Số tiền rút trong ngày/tháng',
  limits: 'Giới hạn số tiền trong ngày/tháng',
  accountBelongs: 'Tài khoản mà nó thuộc về',
  senderName: 'Tên người gửi',
  open: 'bật',
  close: 'Khép kín',
  description: 'Hoạt động Mô tả',
  ipAddress: 'Địa chỉ IP hoạt động',
  beforeOperation: 'Dữ liệu trước hoạt động',
  afterOperation: 'Dữ liệu sau hoạt động',
  LoginBackground: 'Đăng nhập vào nền',
  LoginIP: 'IP đăng nhập',
  PayforIP: 'Trả tiền cho IP',
  activated: 'Số lượng kích hoạt',
  password: 'mật khẩu',
  Success: 'Success',
  UNCONFIRM: 'UNCONFIRM',
  identifyStatus: 'Trạng thái chứng nhận',
  btnLeft: 'Hãy từ từ lắc đầu sang trái',
  btnRight: 'Hãy từ từ lắc đầu sang bên phải',
  btnZoomIn: 'Kéo điện thoại lại gần',
  btnZoomOut: 'Phóng to điện thoại',
  btnFrontAndBlink: 'Hãy nhìn thẳng vào camera và chớp mắt',
  btnRedLight: 'đèn đỏ',
  btnYellowLight: 'đèn vàng',
  btnBlueLight: 'Blu-ray',
  facevideoTip: 'Hiện tại không có video nào được quay',
  facevideo: 'mặt video',
  tip: '(TCB phải tải video lên)',
  btnOrangeLight: 'ánh sáng màu cam',
  btnFront: 'Hãy nhìn thẳng vào camera',
  bankPayType: 'Loại ngân hàng thu tiền',
  connectionStatusOption: [
    {
      value: '',
      label: 'tất cả'
    },
    {
      value: 0,
      label: 'Ngắt kết nối'
    },
    {
      value: 1,
      label: 'Liên kết'
    }
  ],
  add_connectionStatusOption: [
    {
      value: 0,
      label: 'Ngắt kết nối'
    },
    {
      value: 1,
      label: 'Liên kết'
    }
  ],
  callbackStatusOption: [
    {
      value: 2,
      label: 'Gọi lại'
    },
    {
      value: 1,
      label: 'Không được gọi lại'
    }
  ],
  statusOption: [
    {
      value: 1,
      label: 'mở'
    },
    {
      value: 2,
      label: 'đã đóng'
    }
  ],
  transpayTo: [
    {
      value: 0,
      label: 'Thanh toán'
    },
    {
      value: 1,
      label: 'Biên lai'
    }
  ],
  b_transpayTo: [
    {
      value: 1,
      label: 'Biên lai'
    },
    {
      value: 2,
      label: 'Rút tiền'
    },
    {
      value: 3,
      label: 'Sự chi trả'
    }
  ],
  recordStatus: [
    {
      value: 0,
      label: 'xử lý'
    },
    {
      value: 1,
      label: 'thất bại'
    },
    {
      value: 2,
      label: 'thành công'
    }
  ],
  paystatus: [
    {
      value: 0,
      label: 'xử lý'
    },
    {
      value: 1,
      label: ' thành công'
    },
    {
      value: 2,
      label: 'thất bại'
    }
  ],
  rules: {
    // Thiết bị Không
    serialNumber: 'Vui lòng nhập số thiết bị',
    //Số điện thoại
    phone: 'Vui lòng nhập số điện thoại của bạn',
    //Tình trạng kết nối
    connectionStatus: 'Vui lòng chọn trạng thái kết nối',
    //Hạn mức thanh toán trong ngày
    limits: 'Vui lòng nhập giới hạn nhận trong ngày',
    //Giới hạn thanh toán hiện tại
    monthLimits: 'Vui lòng nhập giới hạn thanh toán cho tháng hiện tại'
  },
  mo_history: {
    id: 'id',
    serialNumber: 'Số điện thoại di động',
    phone: 'Nhận số điện thoại',
    userName: 'Tên người nhận thanh toán',
    tranid: 'số giao dịch',
    tranType: 'loại biên lai',
    amount: 'số tiền',
    description: 'Mô tả',
    partnerId: 'Chuyển số điện thoại',
    partnerName: 'Tên bên chuyển nhượng',
    payTime: 'thời gian thanh toán',
    createTime: 'Thời gian tạo',
    merchantOrderNo: 'số đơn đặt hàng của người bán',
    merchantNo: 'số người bán',
    merchantName: 'tên thương gia',
    transactionDate: 'Thời gian nhận tiền'
  },
  all: {
    del: 'Xóa hàng loạt',
    edit: 'Sửa đổi giới hạn theo đợt',
    offorturn: 'Sửa đổi trạng thái kết nối theo đợt:',
    action: 'Hoạt động hàng loạt'
  },
  down: {
    a1: 'Nhập tệp không thể vượt quá 5M，',
    a2: 'Chỉ nhập các tệp định dạng "xls" hoặc "xlsx"!',
    a3: 'Tải mẫu xuống',
    close: 'đóng',
    confirm: 'xác nhận'
  },
  withdrawal: {
    paystatus: [
      {
        value: -1,
        label: 'failed'
      },
      {
        value: 1,
        label: 'success'
      }
    ],
    transferTypes: {
      1: 'Chuyển tiền liên ngân hàng',
      2: 'Chuyển tiền đến TK liên kết',
      3: 'Chuyển khoản nội bộ',
      4: 'thanh toán momo',
      7: 'GoldenPocket',
      72: 'GoldenPocketRelated',
      73: 'GoldenPocketInternal'
    },
    orderNumberTotal: 'Số tiền thực nhận',
    realAmount: 'Tổng số tiền',
    totalfee: 'Phí dịch vụ',
    statistics: 'Thống kê',
    appTransId: 'ID hệ thống',
    phone: 'Số điện thoại',
    serial: 'Số seri',
    transId: 'ID  Zalo',
    payId: 'Tài khoản',
    receiverNumber: 'TK nhận tiền',
    senderNumber: 'TK rút tiền',
    receiverName: 'Tên người nhận',
    amount: 'Số tiền',
    fee: 'Phí dịch vụ',
    total: 'Tổng số tiền',
    status: 'Trạng thái đơn',
    message: 'Ghi chú',
    error: 'Nội dung ghi chú',
    creator: 'TK thao tác',
    created: 'Thời gian',
    momo: {
      orderNumberTotal: 'Số tiền thực nhận',
      realAmount: 'Tổng số tiền',
      totalfee: 'Phí dịch vụ',
      statistics: 'Thống kê',
      fulldata: 'ID hệ thống',
      tranId: ' ID MOMO',
      accountPhone: 'tk MOMO',
      rowCardNum: 'TK nhận tiền',
      partnerName: 'Tên người nhận',
      originalAmount: 'Thực nhận',
      fee: 'Phí dịch vụ',
      amount: 'Tổng tiền',
      sodu: 'Số dư trước giao dịch',
      balance: 'Số dư sau giao dịch',
      errorDesc: 'Ghi chú',
      type: 'Loại giao dịch',
      username: 'TK thao tác',
      status: 'Trạng thái đơn',
      createTime: 'Thời gian tạo',
      serial: 'Số seri'
    }
  },
  owner_merchant_no: 'Người buôn bán',
  capsetAmount: 'Hạn mức chuyển ra hàng tháng'
};



// WEBPACK FOOTER //
// ./src/i18n/lang/vi/device.js